import React from 'react';
import {
    ChevronLeft,
    Lock,
    RefreshCw,
    Send,
    Search,
    FileText,
    Layout,
    DollarSign,
    ShieldCheck,
    Activity,
    Sparkles,
    ArrowRight
} from 'lucide-react';
import './RequirementWorkspace.css';

const requirements = [
    {
        id: 1,
        title: 'System must support 10,000+ concurrent users',
        confidence: 92,
        tags: ['TECHNICAL', 'Approved'],
        assignee: 'AK',
        status: 'Approved'
    },
    {
        id: 2,
        title: 'Real-time fleet tracking with GPS integration',
        confidence: 78,
        tags: ['FUNCTIONAL', 'In Review'],
        assignee: 'SC',
        status: 'In Review',
        active: true
    }
];

const RequirementWorkspace = () => {
    return (
        <div className="workspace">
            <div className="workspace-header">
                <div className="breadcrumb">
                    <ChevronLeft size={16} />
                    <span>Proposals</span>
                    <span className="separator">/</span>
                </div>

                <div className="proposal-title-row">
                    <div className="title-section">
                        <h1>Metro Transit Authority - Fleet Management</h1>
                        <div className="status-badge warning">In Review</div>
                    </div>

                    <div className="action-buttons">
                        <button className="secondary-btn"><Lock size={16} /> Lock</button>
                        <button className="secondary-btn"><RefreshCw size={16} /> Generate</button>
                        <button className="primary-btn"><Send size={16} /> Submit</button>
                    </div>
                </div>

                <div className="proposal-meta">
                    <div className="meta-item">
                        <Activity size={16} className="meta-icon" />
                        <span>Due: Mar 15, 2026</span>
                    </div>
                    <div className="meta-item">
                        <DollarSign size={16} className="meta-icon" />
                        <span>Value: $2.4M</span>
                    </div>
                    <div className="meta-item">
                        <span>Confidence:</span>
                        <div className="confidence-ring">72</div>
                    </div>
                </div>

                <nav className="tab-nav">
                    <div className="tab-item"><Layout size={18} /> Overview</div>
                    <div className="tab-item active"><FileText size={18} /> Requirements</div>
                    <div className="tab-item"><RefreshCw size={18} /> Response Builder</div>
                    <div className="tab-item"><BarChart3 size={18} /> Pricing & BOQ</div>
                    <div className="tab-item"><ShieldCheck size={18} /> Compliance</div>
                    <div className="tab-item"><Activity size={18} /> Activity</div>
                </nav>
            </div>

            <div className="workspace-content">
                <div className="requirements-list">
                    {requirements.map(req => (
                        <div key={req.id} className={`requirement-card ${req.active ? 'active' : ''}`}>
                            <div className="req-header">
                                <h3>{req.title}</h3>
                                <div className="confidence-pill">{req.confidence}</div>
                            </div>
                            <div className="req-footer">
                                <div className="req-tags">
                                    {req.tags.map(tag => (
                                        <span key={tag} className={`tag ${tag.toLowerCase()}`}>{tag}</span>
                                    ))}
                                </div>
                                <div className="req-assignee">{req.assignee}</div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="requirement-detail">
                    <div className="detail-header">
                        <div className="detail-tags">
                            <span className="tag functional">FUNCTIONAL</span>
                            <span className="tag in-review">In Review</span>
                        </div>
                        <div className="detail-assignee">
                            <div className="avatar small blue">SC</div>
                            <span>Sarah Chen</span>
                        </div>
                    </div>

                    <h2>Real-time fleet tracking with GPS integration</h2>

                    <div className="ai-suggestion-card">
                        <div className="ai-header">
                            <Sparkles size={18} className="sparkle-icon" />
                            <span>AI Draft Suggestion</span>
                        </div>
                        <p className="ai-text">
                            Our platform is architected on a distributed microservices framework leveraging Kubernetes orchestration, capable of dynamically scaling to...
                        </p>
                        <div className="ai-actions">
                            <button className="ai-link">Review Full Suggestion <ArrowRight size={14} /></button>
                        </div>
                    </div>

                    <div className="compliance-section">
                        <h3>Compliance Check</h3>
                        <div className="compliance-item success">
                            <ShieldCheck size={16} />
                            <span>Security standard ISO 27001 met</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const BarChart3 = ({ size }) => <Activity size={size} />; // Placeholder for missing icon

export default RequirementWorkspace;
